import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { resourceOperationEfficiency } from "./resource-operation-efficiency.entity";
@Entity('resource_operation_efficiency_log')
export class ResourceOperationEfficiencyLog {

  @PrimaryGeneratedColumn("increment",{name:'resource_operation_efficiency_log_id'})
  resourceOperationEfficiencyLogId:number;
  @Column("int",{
    nullable:false,
    name:"resource_op_eff_id",
    })
  resourceOperationEfficiencyId:number;
  @Column("int",{
    nullable:false,
    name:"old_efficiency",
    default:0
    })
  oldEfficiency:number;
  @Column("int",{
    nullable:false,
    name:"updated_efficiency",
    default:0
    })
  updatedEfficiency:number;
  
  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;

//   @ManyToOne(type => resourceOperationEfficiency, opEff => opEff.effLogsInfo, { nullable: true, })
//   @JoinColumn({ name: "resource_op_eff_id" })
//   resourceOpInfo: resourceOperationEfficiency;
  

}
